import React from 'react';
import { Container } from './Container';
import { Header } from './Header';
import { Main } from './Main';
import { MainColumn } from './MainColumn';
import { Help } from './Help';

export type PageLayoutProps = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  actionpanel?: React.ReactNode;
  footer?: React.ReactNode;
  help?: React.ReactNode;
};

export function PageLayout({
  header,
  children,
  actionpanel,
  footer,
  help,
}: PageLayoutProps) {
  return (
    <Container>
      {header ? <Header>{header}</Header> : null}
      <Main data-testid="page-main">
        <MainColumn>{children}</MainColumn>
        {actionpanel}
      </Main>
      {footer || null}
      {help ? <Help>{help}</Help> : null}
    </Container>
  );
}
